export function getRoomName (roomAttributes, room) {
  let map = {}

  room.attributes.forEach((attribute) => {
    ['roomCategory', 'roomType', 'roomView', 'roomName'].forEach((key) => {
      switch (key) {
        case 'roomName':
          if (roomAttributes[key].hasOwnProperty(attribute.id)) {
            map[key] = attribute
          }
          return
        default:
          if (roomAttributes[key].hasOwnProperty(attribute.id)) {
            map[key] = roomAttributes[key][attribute.id]
            return
          }
      }
    })
  })

  let label = [];
  ['roomCategory', 'roomType', 'roomView'].forEach((key) => {
    if (map.hasOwnProperty(key)) {
      label.push(map[key].value)
    }
  })

  label = label.join(', ')
  const attributeName = map['roomName']
  if (attributeName) {
    const name = attributeName.value
    if (name !== '') {
      if (label) {
        label += ' (' + name + ')'
      } else {
        label = name
      }
    }
  }
  return label
}

export function sanitizeRoomDetails (details) {
  const sanitizedDetails = []
  for (let i = 0; i < details.length; i++) {
    let detail = Object.assign({}, details[i])
    // Remove detail with no codes
    if (detail.codes.length === 0) {
      continue
    }
    // Only use first encountered code for an id
    const codesMap = []
    const newCodes = []
    for (let j = 0; j < detail.codes.length; j++) {
      if (codesMap.hasOwnProperty(detail.codes[j].id)) {
        continue
      }
      codesMap[detail.codes[j].id] = true
      newCodes.push(detail.codes[j])
    }
    sanitizedDetails.push({ ...detail, ...{ codes: newCodes } })
  }
  return sanitizedDetails
}

export function isRoomSaveable (room) {
  if (!room || typeof room !== 'object') { return false }
  if (!room.attributes || !Array.isArray(room.attributes) || room.attributes.length === 0) {
    return false
  }
  return true
}
